import { useLocation } from "@reach/router";
import { useI18next } from "gatsby-plugin-react-i18next";
export default function useQuotePath() { var i18next = useI18next(); var location = useLocation(); return "" + i18next.originalPath + location.search; }
